// Style options for the Dashboard Simulate flow. Each entry maps to the
// `style` field sent to /api/simulations and to the AI prompt versioning
// table in MongoDB (`prompts.{sim_type}.{style}`).
//
// Images come from Unsplash with explicit crop params; keep them small
// because the simulate page already loads heavy catalog thumbnails.
export const STYLES = [
  {
    id: "ART_DECO",
    label: "Art Deco",
    sub: "Geometric · auriu · simetric",
    img: "https://images.unsplash.com/photo-1758541214332-3cb54533c469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxjbGFzc2ljJTIwYXJjaGl0ZWN0dXJhbCUyMHdhbGwlMjBtb2xkaW5nJTIwZGV0YWlsfGVufDB8fHx8MTc3NzY5OTgwMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "CLASSIC",
    label: "Classic",
    sub: "Versailles · alb · ornamental",
    img: "https://images.unsplash.com/photo-1762795966465-283c02fb3e92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxjbGFzc2ljJTIwYXJjaGl0ZWN0dXJhbCUyMHdhbGwlMjBtb2xkaW5nJTIwZGV0YWlsfGVufDB8fHx8MTc3NzY5OTgwMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "MODERN",
    label: "Modern",
    sub: "Minimalist · linii curate",
    img: "https://images.unsplash.com/photo-1621293954908-907159247fc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc3Njk5ODAxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "NEOCLASSIC",
    label: "Neoclassic",
    sub: "Pilastri · simetrie · pastel",
    img: "https://images.unsplash.com/photo-1761471567052-011445647b89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxjbGFzc2ljJTIwYXJjaGl0ZWN0dXJhbCUyMHdhbGwlMjBtb2xkaW5nJTIwZGV0YWlsfGVufDB8fHx8MTc3NzY5OTgwMXww&ixlib=rb-4.1.0&q=85",
  },
];
